// 2026-09-21 - FormuLearning - API 오류 문장 추출 (이슈 #77)
// 파일 위치: frontend/src/lib/apiError.ts
// FastAPI 는 규칙 위반을 `detail` 문자열(409·404)이나 검증 오류 배열(422)로 돌려준다.
// 폴더·이름 조작의 409 문장은 사용자에게 그대로 보여 주도록 서버가 쓴다(BR-PRJ-05~07).
// 2026-09-23 수정 - 이슈 #85: 사유 코드가 붙은 422 본문 `{code, message, ...}`(인터페이스 v1.14)의 message 를 읽는다.

export function apiErrorMessage(e: unknown, fallback = '요청을 처리하지 못했습니다.'): string {
  const detail = (e as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail) && detail[0]?.msg) return String(detail[0].msg)
  if (detail && typeof detail === 'object' && typeof (detail as { message?: unknown }).message === 'string') {
    return (detail as { message: string }).message
  }
  return fallback
}
